'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.JobApplication = exports.ApplicationModal = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _desc, _value, _class;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _server = require('react-dom/server');

var _server2 = _interopRequireDefault(_server);

var _classList = require('class-list');

var _classList2 = _interopRequireDefault(_classList);

var _modal = require('modal');

var _modal2 = _interopRequireDefault(_modal);

var _text = require('components/field/text');

var _text2 = _interopRequireDefault(_text);

var _list = require('components/field/list');

var _list2 = _interopRequireDefault(_list);

var _checkbox = require('components/field/checkbox');

var _checkbox2 = _interopRequireDefault(_checkbox);

var _textarea = require('components/field/textarea');

var _textarea2 = _interopRequireDefault(_textarea);

var _date = require('components/field/date');

var _date2 = _interopRequireDefault(_date);

var _lists = require('lists');

var _animationHelper = require('animation-helper');

var _animationHelper2 = _interopRequireDefault(_animationHelper);

var _decorators = require('decorators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextField = function TextField(props) {
	return _react2.default.createElement(_text2.default, _extends({}, props, { labelOutside: true }));
};
var ListBox = function ListBox(props) {
	return _react2.default.createElement(_list2.default, _extends({}, props, { labelOutside: true }));
};
var TextArea = function TextArea(props) {
	return _react2.default.createElement(_textarea2.default, _extends({}, props, { labelOutside: true }));
};
var DateField = function DateField(props) {
	return _react2.default.createElement(_date2.default, _extends({}, props, { labelOutside: true }));
};

var ApplicationModal = exports.ApplicationModal = function (_Modal) {
	_inherits(ApplicationModal, _Modal);

	function ApplicationModal() {
		_classCallCheck(this, ApplicationModal);

		return _possibleConstructorReturn(this, (ApplicationModal.__proto__ || Object.getPrototypeOf(ApplicationModal)).apply(this, arguments));
	}

	_createClass(ApplicationModal, [{
		key: 'content',
		get: function get() {
			return _react2.default.createElement(JobApplication, { closeModal: this.close, job: this.props.job });
		}
	}], [{
		key: 'show',
		value: function show(job) {
			this.showModal(_react2.default.createElement(ApplicationModal, { className: 'application', job: job }));
		}
	}]);

	return ApplicationModal;
}(_modal2.default);

var Wizard = (_class = function (_Component) {
	_inherits(Wizard, _Component);

	function Wizard() {
		var _ref;

		var _temp, _this2, _ret;

		_classCallCheck(this, Wizard);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = Wizard.__proto__ || Object.getPrototypeOf(Wizard)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
			page: 0,
			nextPage: null,
			canMoveForward: false
		}, _temp), _possibleConstructorReturn(_this2, _ret);
	}

	_createClass(Wizard, [{
		key: 'nextPage',
		value: function nextPage() {
			this.setState(function (state) {
				return { page: state.page + 1, canMoveForward: false };
			});
		}
	}, {
		key: 'previousPage',
		value: function previousPage() {
			this.setState(function (state) {
				return { page: state.page - 1, canMoveForward: false };
			});
		}
	}, {
		key: 'setCanMoveForward',
		value: function setCanMoveForward(value) {
			if (value != this.state.canMoveForward) this.setState({ canMoveForward: value });
		}
	}, {
		key: 'gotBody',
		value: function gotBody(node) {
			this.bodyElement = node;
		}
	}, {
		key: 'render',
		value: function render() {
			var P = _react2.default.Children.toArray(this.props.children);
			var thePage = P[this.state.page];
			return _react2.default.createElement(
				'div',
				{ className: 'wizard' },
				_react2.default.createElement(
					'div',
					{ className: 'wizard-body', ref: this.gotBody },
					_react2.default.cloneElement(P[this.state.page], {
						canMoveForward: this.state.canMoveForward,
						setCanMoveForward: this.setCanMoveForward
					})
				),
				_react2.default.createElement(
					'div',
					{ className: 'controls', 'data-page-number': this.state.page, 'data-page-count': P.length },
					this.state.page == 0 ? null : _react2.default.createElement(
						'button',
						{ className: 'btn btn-default', onClick: this.previousPage },
						'Back'
					),
					_react2.default.createElement(
						'button',
						{ className: 'btn btn-primary', disabled: !this.state.canMoveForward, onClick: this.nextPage },
						thePage.props.nextButtonTitle ? thePage.props.nextButtonTitle : 'Next'
					)
				)
			);
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			var _this3 = this;

			if (this.state.page != prevState.page) {
				var S = this.bodyElement.scrollTop;
				if (S > 0) {
					var A = new _animationHelper2.default(50, 'ease', function (percent) {
						return _this3.bodyElement.scrollTop = (1 - percent) * S;
					});
					A.start();
				}
			}
		}
	}]);

	return Wizard;
}(_react.Component), (_applyDecoratedDescriptor(_class.prototype, 'nextPage', [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'nextPage'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'previousPage', [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'previousPage'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setCanMoveForward', [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'setCanMoveForward'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'gotBody', [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'gotBody'), _class.prototype)), _class);

var Page16 = function (_Component2) {
	_inherits(Page16, _Component2);

	function Page16() {
		_classCallCheck(this, Page16);

		return _possibleConstructorReturn(this, (Page16.__proto__ || Object.getPrototypeOf(Page16)).apply(this, arguments));
	}

	_createClass(Page16, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement('section', null);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.props.submitForm();
		}
	}]);

	return Page16;
}(_react.Component);

var Page15 = function (_Component3) {
	_inherits(Page15, _Component3);

	function Page15(props) {
		_classCallCheck(this, Page15);

		var _this5 = _possibleConstructorReturn(this, (Page15.__proto__ || Object.getPrototypeOf(Page15)).call(this, props));

		_this5.state = Object.assign({}, props.page);
		/*
  	page15: {agree: false}
  */
		return _this5;
	}

	_createClass(Page15, [{
		key: 'render',
		value: function render() {
			var _this6 = this;

			return _react2.default.createElement(
				'section',
				null,
				_react2.default.createElement(
					'header',
					null,
					_react2.default.createElement(
						'h4',
						null,
						'Agreement'
					)
				),
				_react2.default.createElement(
					'p',
					null,
					'I certify that the facts contained in this application are true and complete to the best of my knowledge and understand that, if employed, falsified statements on this application shall be grounds for dismissal at any time without any previous notice. I hereby give The Pool & Spa House permission to contact schools, previous employers (unless otherwise indicated), references, and others. I further authorize the company to obtain a copy of my driving record. I hereby release The Pool & Spa House from any liability as a result of such contacts, inquiries, or records in order to ascertain my qualification and fitness for employment.'
				),
				_react2.default.createElement(_checkbox2.default, { label: 'Yes, I agree. *', value: this.state.agree, setValue: function setValue(value) {
						return _this6.setState({ agree: value });
					} })
			);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.validate();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			var _this7 = this;

			if (Object.keys(this.props.page).filter(function (v) {
				return prevState[v] != _this7.state[v];
			}).length) {
				this.validate();
				this.props.updatePage(this.state);
			}
		}
	}, {
		key: 'validate',
		value: function validate() {
			var _this8 = this;

			if (Object.keys(this.props.page).filter(function (v) {
				return !_this8.state[v];
			}).length) {
				this.props.setCanMoveForward(false);
				return;
			}
			this.props.setCanMoveForward(true);
		}
	}]);

	return Page15;
}(_react.Component);

var Page14 = function (_Component4) {
	_inherits(Page14, _Component4);

	function Page14(props) {
		_classCallCheck(this, Page14);

		var _this9 = _possibleConstructorReturn(this, (Page14.__proto__ || Object.getPrototypeOf(Page14)).call(this, props));

		_this9.state = Object.assign({}, props.page);
		/*
  	page14: {
  		reference1Name: "",
  		reference1Relationship: "",
  		reference1Email: "",
  		reference1Phone: "",
  		reference2Name: "",
  		reference2Relationship: "",
  		reference2Email: "",
  		reference2Phone: ""
  	},
  */
		return _this9;
	}

	_createClass(Page14, [{
		key: 'render',
		value: function render() {
			var _this10 = this;

			return _react2.default.createElement(
				'section',
				null,
				_react2.default.createElement(
					'section',
					null,
					_react2.default.createElement(
						'header',
						null,
						_react2.default.createElement(
							'h4',
							null,
							'Personal Reference 1'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'item-row' },
						_react2.default.createElement(TextField, { label: 'Name *', value: this.state.reference1Name, setValue: function setValue(value) {
								return _this10.setState({ reference1Name: value });
							} }),
						_react2.default.createElement(ListBox, { label: 'Relationship *', value: { id: this.state.reference1Relationship }, setValue: function setValue(value) {
								return _this10.setState({ reference1Relationship: value ? value.id : "" });
							}, options: _lists.Relationships })
					),
					_react2.default.createElement(
						'div',
						{ className: 'item-row' },
						_react2.default.createElement(TextField, { label: 'Email *', value: this.state.reference1Email, setValue: function setValue(value) {
								return _this10.setState({ reference1Email: value });
							} }),
						_react2.default.createElement(TextField, { label: 'Phone *', value: this.state.reference1Phone, setValue: function setValue(value) {
								return _this10.setState({ reference1Phone: value });
							} })
					)
				),
				_react2.default.createElement(
					'section',
					null,
					_react2.default.createElement(
						'header',
						null,
						_react2.default.createElement(
							'h4',
							null,
							'Personal Reference 2'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'item-row' },
						_react2.default.createElement(TextField, { label: 'Name *', value: this.state.reference2Name, setValue: function setValue(value) {
								return _this10.setState({ reference2Name: value });
							} }),
						_react2.default.createElement(ListBox, { label: 'Relationship *', value: { id: this.state.reference2Relationship }, setValue: function setValue(value) {
								return _this10.setState({ reference2Relationship: value ? value.id : "" });
							}, options: _lists.Relationships })
					),
					_react2.default.createElement(
						'div',
						{ className: 'item-row' },
						_react2.default.createElement(TextField, { label: 'Email *', value: this.state.reference2Email, setValue: function setValue(value) {
								return _this10.setState({ reference2Email: value });
							} }),
						_react2.default.createElement(TextField, { label: 'Phone *', value: this.state.reference2Phone, setValue: function setValue(value) {
								return _this10.setState({ reference2Phone: value });
							} })
					)
				)
			);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.validate();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			var _this11 = this;

			if (Object.keys(this.props.page).filter(function (v) {
				return prevState[v] != _this11.state[v];
			}).length) {
				this.validate();
				this.props.updatePage(this.state);
			}
		}
	}, {
		key: 'validate',
		value: function validate() {
			var _this12 = this;

			if (Object.keys(this.props.page).filter(function (v) {
				return !_this12.state[v];
			}).length) {
				this.props.setCanMoveForward(false);
				return;
			}
			this.props.setCanMoveForward(true);
		}
	}]);

	return Page14;
}(_react.Component);

var Page13 = function (_Component5) {
	_inherits(Page13, _Component5);

	function Page13(props) {
		_classCallCheck(this, Page13);

		var _this13 = _possibleConstructorReturn(this, (Page13.__proto__ || Object.getPrototypeOf(Page13)).call(this, props));

		_this13.state = Object.assign({}, props.page);
		/*
  	page13: {
  		leastFavoriteJobAndWhy: "",
  		difficultPartOfCustomerService: "",
  		funniestThing: ""
  	},
  */
		return _this13;
	}

	_createClass(Page13, [{
		key: 'render',
		value: function render() {
			var _this14 = this;

			return _react2.default.createElement(
				'section',
				null,
				_react2.default.createElement(TextArea, { label: 'What was your least favorite job? What did you not like about it? *',
					value: this.state.leastFavoriteJobAndWhy, setValue: function setValue(value) {
						return _this14.setState({ leastFavoriteJobAndWhy: value });
					} }),
				_react2.default.createElement(TextArea, { label: 'What do you feel is the most difficult part of customer service and sales? How do you deal with this? *',
					value: this.state.difficultPartOfCustomerService, setValue: function setValue(value) {
						return _this14.setState({ difficultPartOfCustomerService: value });
					} }),
				_react2.default.createElement(TextArea, { label: 'What was the funniest thing that ever happened to you at work? *',
					value: this.state.funniestThing, setValue: function setValue(value) {
						return _this14.setState({ funniestThing: value });
					} })
			);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.validate();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			var _this15 = this;

			if (Object.keys(this.props.page).filter(function (v) {
				return prevState[v] != _this15.state[v];
			}).length) {
				this.validate();
				this.props.updatePage(this.state);
			}
		}
	}, {
		key: 'validate',
		value: function validate() {
			var _this16 = this;

			if (Object.keys(this.props.page).filter(function (v) {
				return !_this16.state[v];
			}).length) {
				this.props.setCanMoveForward(false);
				return;
			}
			this.props.setCanMoveForward(true);
		}
	}]);

	return Page13;
}(_react.Component);

var Page12 = function (_Component6) {
	_inherits(Page12, _Component6);

	function Page12(props) {
		_classCallCheck(this, Page12);

		var _this17 = _possibleConstructorReturn(this, (Page12.__proto__ || Object.getPrototypeOf(Page12)).call(this, props));

		_this17.state = Object.assign({}, props.page);
		/*
  	page12: {
  		greatestStrengths: "",
  		areasForImprovement: "",
  		difficultPartOfManagement: "",
  		whatMakesAGoodManager: ""
  	},
  */
		return _this17;
	}

	_createClass(Page12, [{
		key: 'render',
		value: function render() {
			var _this18 = this;

			/* Q2 original text: As your skills and abilities related to your work experience, what are the areas of improvement? */
			return _react2.default.createElement(
				'section',
				null,
				_react2.default.createElement(TextArea, { label: 'What are your greatest strengths? *', value: this.state.greatestStrengths, setValue: function setValue(value) {
						return _this18.setState({ greatestStrengths: value });
					} }),
				_react2.default.createElement(TextArea, { label: 'What are your greatest areas of improvement as they relate to work experience? *',
					value: this.state.areasForImprovement, setValue: function setValue(value) {
						return _this18.setState({ areasForImprovement: value });
					} }),
				_react2.default.createElement(TextArea, { label: 'What is the most difficult part of managing the work of others? *',
					value: this.state.difficultPartOfManagement, setValue: function setValue(value) {
						return _this18.setState({ difficultPartOfManagement: value });
					} }),
				_react2.default.createElement(TextArea, { label: 'Think of the best supervisor or manager you\'ve worked with. What characteristics made that person a good manager? *',
					value: this.state.whatMakesAGoodManager, setValue: function setValue(value) {
						return _this18.setState({ whatMakesAGoodManager: value });
					} })
			);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.validate();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			var _this19 = this;

			if (Object.keys(this.props.page).filter(function (v) {
				return prevState[v] != _this19.state[v];
			}).length) {
				this.validate();
				this.props.updatePage(this.state);
			}
		}
	}, {
		key: 'validate',
		value: function validate() {
			var _this20 = this;

			if (Object.keys(this.props.page).filter(function (v) {
				return !_this20.state[v];
			}).length) {
				this.props.setCanMoveForward(false);
				return;
			}
			this.props.setCanMoveForward(true);
		}
	}]);

	return Page12;
}(_react.Component);

var Page11 = function (_Component7) {
	_inherits(Page11, _Component7);

	/*
 	return {
 		employerName: "",
 		phone: "",
 		address: "",
 		city: "",
 		state: "",
 		zip: "",
 		supervisorName: "",
 		supervisorTitle: "",
 		startDate: "",
 		endDate: "",
 		startingPay: "",
 		endingPay: "",
 		duties: "",
 		canContact: true,
 		hasMore: false
 	}
 */
	function Page11(props) {
		_classCallCheck(this, Page11);

		var _this21 = _possibleConstructorReturn(this, (Page11.__proto__ || Object.getPrototypeOf(Page11)).call(this, props));

		_this21.state = Object.assign({}, _this21.props.page);
		return _this21;
	}

	_createClass(Page11, [{
		key: 'render',
		value: function render() {
			var _this22 = this;

			return _react2.default.createElement(
				'section',
				null,
				_react2.default.createElement(
					'header',
					null,
					_react2.default.createElement(
						'h4',
						null,
						this.props.isFirst ? "Your most recent job information." : "Additional job information."
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'item-row' },
					_react2.default.createElement(TextField, { label: 'Employer Name *', value: this.state.employerName, setValue: function setValue(value) {
							return _this22.setState({ employerName: value });
						} }),
					_react2.default.createElement(TextField, { label: 'Phone *', value: this.state.phone, setValue: function setValue(value) {
							return _this22.setState({ phone: value });
						} })
				),
				_react2.default.createElement(
					'div',
					{ className: 'item-row' },
					_react2.default.createElement(TextField, { label: 'Address *', value: this.state.address, setValue: function setValue(value) {
							return _this22.setState({ address: value });
						} }),
					_react2.default.createElement(TextField, { label: 'City *', value: this.state.city, setValue: function setValue(value) {
							return _this22.setState({ city: value });
						} }),
					_react2.default.createElement(ListBox, { label: 'State *', value: { id: this.state.state }, setValue: function setValue(value) {
							return _this22.setState({ state: value ? value.id : null });
						}, options: _lists.States }),
					_react2.default.createElement(TextField, { label: 'Zip *', value: this.state.zip, setValue: function setValue(value) {
							return _this22.setState({ zip: value });
						} })
				),
				_react2.default.createElement(
					'div',
					{ className: 'item-row' },
					_react2.default.createElement(TextField, { label: 'Supervisor\'s Name *', value: this.state.supervisorName, setValue: function setValue(value) {
							return _this22.setState({ supervisorName: value });
						} }),
					_react2.default.createElement(TextField, { label: 'Supervisor\'s Title *', value: this.state.supervisorTitle, setValue: function setValue(value) {
							return _this22.setState({ supervisorTitle: value });
						} })
				),
				_react2.default.createElement(
					'div',
					{ className: 'item-row' },
					_react2.default.createElement(DateField, { label: 'Start Date *', value: this.state.startDateValue || this.state.startDate || "",
						setValue: function setValue(value) {
							return _this22.setState({ startDateValue: value, startDate: _date.View.format(value, { ignoreYear: false, defaultValue: '' }) });
						}
					}),
					_react2.default.createElement(DateField, { label: 'End Date (Leave blank if still here)', value: this.state.endDateValue || this.state.endDate || "",
						setValue: function setValue(value) {
							return _this22.setState({ endDateValue: value, endDate: _date.View.format(value, { ignoreYear: false, defaultValue: '(Current)' }) });
						}
					})
				),
				_react2.default.createElement(
					'div',
					{ className: 'item-row' },
					_react2.default.createElement(TextField, { label: 'Starting Pay Rate *', value: this.state.startingPay, setValue: function setValue(value) {
							return _this22.setState({ startingPay: value });
						} }),
					_react2.default.createElement(TextField, { label: 'Ending Pay Rate', value: this.state.endingPay, setValue: function setValue(value) {
							return _this22.setState({ endingPay: value });
						} })
				),
				_react2.default.createElement(
					'div',
					{ className: 'item-row' },
					_react2.default.createElement(TextArea, { label: 'Describe the duties you performed, skills used, and position held *', value: this.state.duties, setValue: function setValue(value) {
							return _this22.setState({ duties: value });
						} })
				),
				_react2.default.createElement(_checkbox2.default, { label: 'Yes, you can contact this employer.', value: this.state.canContact, setValue: function setValue(value) {
						return _this22.setState({ canContact: value });
					} }),
				_react2.default.createElement(_checkbox2.default, { label: 'Yes, I have another job to enter.', value: this.state.hasMore, setValue: function setValue(value) {
						return _this22.setState({ hasMore: value });
					} })
			);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.validate();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			var _this23 = this;

			if (Object.keys(this.props.page).filter(function (v) {
				return prevState[v] != _this23.state[v];
			}).length) {
				this.validate();
				this.props.updatePage(this.state);
			}
		}
	}, {
		key: 'validate',
		value: function validate() {
			var _this24 = this;

			var notEmpty = function notEmpty(value) {
				return String(value).replace(/\s*/g, '') != '';
			};
			var fields = ['employerName', 'phone', 'address', 'city', 'state', 'zip', 'supervisorName', 'supervisorTitle', 'startDate', 'startingPay', 'duties'];
			if (fields.filter(function (v) {
				return !notEmpty(_this24.state[v]);
			}).length) {
				this.props.setCanMoveForward(false);
				return;
			}
			this.props.setCanMoveForward(true);
		}
	}]);

	return Page11;
}(_react.Component);

var Page10 = function (_Component8) {
	_inherits(Page10, _Component8);

	function Page10(props) {
		_classCallCheck(this, Page10);

		var _this25 = _possibleConstructorReturn(this, (Page10.__proto__ || Object.getPrototypeOf(Page10)).call(this, props));

		_this25.state = Object.assign({}, _this25.props.page);
		return _this25;
	}

	_createClass(Page10, [{
		key: 'render',
		value: function render() {
			var _this26 = this;

			return _react2.default.createElement(
				'section',
				null,
				_react2.default.createElement(
					'section',
					null,
					_react2.default.createElement(
						'header',
						null,
						_react2.default.createElement(
							'h4',
							null,
							'Tell us about any additional education or training.'
						)
					),
					_react2.default.createElement(TextArea, { value: this.state.additionalEducation, setValue: function setValue(value) {
							return _this26.setState({ additionalEducation: value });
						} })
				),
				_react2.default.createElement(
					'section',
					null,
					_react2.default.createElement(
						'header',
						null,
						_react2.default.createElement(
							'h4',
							null,
							'List other specific skills you have to offer for this job opening.'
						)
					),
					_react2.default.createElement(TextArea, { value: this.state.skills, setValue: function setValue(value) {
							return _this26.setState({ skills: value });
						} })
				)
			);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.validate();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			var _this27 = this;

			if (Object.keys(this.props.page).filter(function (v) {
				return prevState[v] != _this27.state[v];
			}).length) {
				this.validate();
				this.props.updatePage(this.state);
			}
		}
	}, {
		key: 'validate',
		value: function validate() {
			this.props.setCanMoveForward(true);
		}
	}]);

	return Page10;
}(_react.Component);

var Page9 = function (_Component9) {
	_inherits(Page9, _Component9);

	function Page9(props) {
		_classCallCheck(this, Page9);

		var _this28 = _possibleConstructorReturn(this, (Page9.__proto__ || Object.getPrototypeOf(Page9)).call(this, props));

		_this28.state = Object.assign({}, _this28.props.page);
		return _this28;
	}

	_createClass(Page9, [{
		key: 'render',
		value: function render() {
			var _this29 = this;

			return _react2.default.createElement(
				'section',
				null,
				_react2.default.createElement(
					'header',
					null,
					_react2.default.createElement(
						'h4',
						null,
						'Tell us about your Military Service.'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'item-row' },
					_react2.default.createElement(TextField, { label: 'Military Rank *', value: this.state.militaryRank, setValue: function setValue(value) {
							return _this29.setState({ militaryRank: value });
						} }),
					_react2.default.createElement(TextField, { label: 'Military Branch *', value: this.state.militaryBranch, setValue: function setValue(value) {
							return _this29.setState({ militaryBranch: value });
						} })
				),
				_react2.default.createElement(TextArea, { label: 'Describe your military service *', value: this.state.militaryService, setValue: function setValue(value) {
						return _this29.setState({ militaryService: value });
					} })
			);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.validate();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			var _this30 = this;

			if (Object.keys(this.props.page).filter(function (v) {
				return prevState[v] != _this30.state[v];
			}).length) {
				this.validate();
				this.props.updatePage(this.state);
			}
		}
	}, {
		key: 'validate',
		value: function validate() {
			var _this31 = this;

			if (Object.keys(this.props.page).filter(function (v) {
				return !_this31.state[v];
			}).length) {
				this.props.setCanMoveForward(false);
				return;
			}
			this.props.setCanMoveForward(true);
		}
	}]);

	return Page9;
}(_react.Component);

var Page8 = function (_Component10) {
	_inherits(Page8, _Component10);

	function Page8(props) {
		_classCallCheck(this, Page8);

		var _this32 = _possibleConstructorReturn(this, (Page8.__proto__ || Object.getPrototypeOf(Page8)).call(this, props));

		_this32.state = Object.assign({}, _this32.props.page);
		return _this32;
	}

	_createClass(Page8, [{
		key: 'render',
		value: function render() {
			var _this33 = this;

			return _react2.default.createElement(
				'section',
				null,
				_react2.default.createElement(
					'header',
					null,
					_react2.default.createElement(
						'h4',
						null,
						'Tell us about your Trade or Professional School. *'
					)
				),
				_react2.default.createElement(TextArea, { value: this.state.tradeSchool, setValue: function setValue(value) {
						return _this33.setState({ tradeSchool: value });
					} })
			);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.validate();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			var _this34 = this;

			if (Object.keys(this.props.page).filter(function (v) {
				return prevState[v] != _this34.state[v];
			}).length) {
				this.validate();
				this.props.updatePage(this.state);
			}
		}
	}, {
		key: 'validate',
		value: function validate() {
			if (this.state.tradeSchool) {
				this.props.setCanMoveForward(true);
				return;
			}
			this.props.setCanMoveForward(false);
		}
	}]);

	return Page8;
}(_react.Component);

var Page7 = function (_Component11) {
	_inherits(Page7, _Component11);

	function Page7(props) {
		_classCallCheck(this, Page7);

		var _this35 = _possibleConstructorReturn(this, (Page7.__proto__ || Object.getPrototypeOf(Page7)).call(this, props));

		_this35.state = Object.assign({}, _this35.props.page);
		return _this35;
	}

	_createClass(Page7, [{
		key: 'render',
		value: function render() {
			var _this36 = this;

			return _react2.default.createElement(
				'section',
				null,
				_react2.default.createElement(
					'header',
					null,
					_react2.default.createElement(
						'h4',
						null,
						'Tell us about your College.'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'item-row' },
					_react2.default.createElement(TextField, { label: 'Name *', value: this.state.collegeName, setValue: function setValue(value) {
							return _this36.setState({ collegeName: value });
						} }),
					_react2.default.createElement(TextField, { label: 'City *', value: this.state.collegeCity, setValue: function setValue(value) {
							return _this36.setState({ collegeCity: value });
						} }),
					_react2.default.createElement(ListBox, { label: 'State *', value: { id: this.state.collegeState }, setValue: function setValue(value) {
							return _this36.setState({ collegeState: value ? value.id : null });
						}, options: _lists.States })
				),
				null
				/*
    <div className='item-row'>
    	<DateField label='Start Date' value={this.state.collegeStartValue || this.state.collegeStart || ""}
    		setValue={value => this.setState({ collegeStartValue: value, collegeStart: DateView.format(value, { ignoreYear: false, defaultValue: '' }) })}
    	/>
    	<DateField label='End Date (Leave blank if still attending)' value={this.state.collegeEndValue || this.state.collegeEnd || ""}
    		setValue={value => this.setState({ collegeEndValue: value, collegeEnd: DateView.format(value, { ignoreYear: false, defaultValue: '(Still attending)' }) })}
    	/>
    </div>
    */
				,
				_react2.default.createElement(_checkbox2.default, { label: 'Yes, I graduated.', value: this.state.collegeGraduated, setValue: function setValue(value) {
						return _this36.setState({ collegeGraduated: value });
					} }),
				this.state.collegeGraduated ? _react2.default.createElement(
					'div',
					{ className: 'item-row' },
					_react2.default.createElement(TextField, { label: 'College Degree *', value: this.state.collegeDegree, setValue: function setValue(value) {
							return _this36.setState({ collegeDegree: value });
						} }),
					_react2.default.createElement(TextField, { label: 'Year Received *', value: this.state.collegeDegreeYear, setValue: function setValue(value) {
							return _this36.setState({ collegeDegreeYear: value });
						} })
				) : null
			);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.validate();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			var _this37 = this;

			if (Object.keys(this.props.page).filter(function (v) {
				return prevState[v] != _this37.state[v];
			}).length) {
				this.validate();
				this.props.updatePage(this.state);
			}
		}
	}, {
		key: 'validate',
		value: function validate() {
			if (this.state.collegeName && this.state.collegeCity && this.state.collegeState /* && this.state.collegeStart */) {
					if (this.state.collegeGraduated) {
						if (this.state.collegeDegree && this.state.collegeDegreeYear) {
							this.props.setCanMoveForward(true);
							return;
						}
					} else {
						this.props.setCanMoveForward(true);
						return;
					}
				}
			this.props.setCanMoveForward(false);
		}
	}]);

	return Page7;
}(_react.Component);

var Page6 = function (_Component12) {
	_inherits(Page6, _Component12);

	function Page6(props) {
		_classCallCheck(this, Page6);

		var _this38 = _possibleConstructorReturn(this, (Page6.__proto__ || Object.getPrototypeOf(Page6)).call(this, props));

		_this38.state = Object.assign({}, _this38.props.page);
		return _this38;
	}

	_createClass(Page6, [{
		key: 'render',
		value: function render() {
			var _this39 = this;

			return _react2.default.createElement(
				'section',
				null,
				_react2.default.createElement(
					'header',
					null,
					_react2.default.createElement(
						'h4',
						null,
						'Tell us about your High School.'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'item-row' },
					_react2.default.createElement(TextField, { label: 'Name *', value: this.state.highSchoolName, setValue: function setValue(value) {
							return _this39.setState({ highSchoolName: value });
						} }),
					_react2.default.createElement(TextField, { label: 'City *', value: this.state.highSchoolCity, setValue: function setValue(value) {
							return _this39.setState({ highSchoolCity: value });
						} }),
					_react2.default.createElement(ListBox, { label: 'State *\t', value: { id: this.state.highSchoolState }, setValue: function setValue(value) {
							return _this39.setState({ highSchoolState: value ? value.id : null });
						}, options: _lists.States })
				),
				null
				/*
    <div className='item-row'>
    	<DateField label='Start Date' value={this.state.highSchoolStartValue || this.state.highSchoolStart || ""}
    		setValue={value => this.setState({ highSchoolStartValue: value, highSchoolStart: DateView.format(value, { ignoreYear: false, defaultValue: '' }) })}
    	/>
    	<DateField label='End Date (Leave blank if still attending)' value={this.state.highSchoolEndValue || this.state.highSchoolEnd || ""}
    		setValue={value => this.setState({ highSchoolEndValue: value, highSchoolEnd: DateView.format(value, { ignoreYear: false, defaultValue: '(Still attending)' }) })}
    	/>
    </div>
    */
				,
				_react2.default.createElement(_checkbox2.default, { label: 'Yes, I graduated.', value: this.state.highSchoolGraduated, setValue: function setValue(value) {
						return _this39.setState({ highSchoolGraduated: value });
					} })
			);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.validate();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			var _this40 = this;

			if (Object.keys(this.props.page).filter(function (v) {
				return prevState[v] != _this40.state[v];
			}).length) {
				this.validate();
				this.props.updatePage(this.state);
			}
		}
	}, {
		key: 'validate',
		value: function validate() {
			if (this.state.highSchoolName && this.state.highSchoolCity && this.state.highSchoolState /* && this.state.highSchoolStart */) {
					this.props.setCanMoveForward(true);
				} else {
				this.props.setCanMoveForward(false);
			}
		}
	}]);

	return Page6;
}(_react.Component);

var Page5 = function (_Component13) {
	_inherits(Page5, _Component13);

	function Page5(props) {
		_classCallCheck(this, Page5);

		var _this41 = _possibleConstructorReturn(this, (Page5.__proto__ || Object.getPrototypeOf(Page5)).call(this, props));

		_this41.state = Object.assign({}, _this41.props.page);
		return _this41;
	}

	_createClass(Page5, [{
		key: 'render',
		value: function render() {
			var _this42 = this;

			return _react2.default.createElement(
				'section',
				null,
				_react2.default.createElement(
					'header',
					null,
					_react2.default.createElement(
						'h4',
						null,
						'What is your level of education?'
					)
				),
				_react2.default.createElement(_checkbox2.default, { asToggle: true, label: 'High School', value: this.state.educationHS, setValue: function setValue(value) {
						return _this42.setState({ educationHS: value });
					} }),
				_react2.default.createElement(_checkbox2.default, { asToggle: true, label: 'College', value: this.state.educationCollege, setValue: function setValue(value) {
						return _this42.setState({ educationCollege: value });
					} }),
				_react2.default.createElement(_checkbox2.default, { asToggle: true, label: 'Trade or Professional School', value: this.state.educationTrade, setValue: function setValue(value) {
						return _this42.setState({ educationTrade: value });
					} }),
				_react2.default.createElement(_checkbox2.default, { asToggle: true, label: 'Military Service', value: this.state.educationMilitary, setValue: function setValue(value) {
						return _this42.setState({ educationMilitary: value });
					} })
			);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.props.setCanMoveForward(true);
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			var _this43 = this;

			if (['educationHS', 'educationCollege', 'educationTrade', 'educationMilitary'].filter(function (v) {
				return prevState[v] != _this43.state[v];
			}).length) {
				this.props.updatePage(this.state);
				this.props.setCanMoveForward(true);
			}
		}
	}]);

	return Page5;
}(_react.Component);

var Page4 = function (_Component14) {
	_inherits(Page4, _Component14);

	function Page4(props) {
		_classCallCheck(this, Page4);

		var _this44 = _possibleConstructorReturn(this, (Page4.__proto__ || Object.getPrototypeOf(Page4)).call(this, props));

		_this44.state = Object.assign({}, _this44.props.page);
		return _this44;
	}

	_createClass(Page4, [{
		key: 'render',
		value: function render() {
			var _this45 = this;

			return _react2.default.createElement(
				'section',
				null,
				_react2.default.createElement(_checkbox2.default, { asToggle: true, label: 'Do you have a valid drivers license?', value: this.state.driversLicense, setValue: function setValue(value) {
						return _this45.setState({ driversLicense: value });
					} }),
				_react2.default.createElement(TextField, { asRow: true, label: 'How many traffic incidents have you had in the last three years? *', value: this.state.trafficIncidents, setValue: function setValue(value) {
						return _this45.setState({ trafficIncidents: value });
					} }),
				_react2.default.createElement(TextField, { asRow: true, label: 'How many moving violations have you had in the last three years? *', value: this.state.movingViolations, setValue: function setValue(value) {
						return _this45.setState({ movingViolations: value });
					} })
			);
		}
	}, {
		key: 'validate',
		value: function validate() {
			if (!isNaN(Number(this.state.trafficIncidents)) && !isNaN(Number(this.state.movingViolations))) {
				this.props.setCanMoveForward(true);
				return;
			}

			this.props.setCanMoveForward(false);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.validate();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			var _this46 = this;

			if (['driversLicense', 'trafficIncidents', 'movingViolations'].filter(function (v) {
				return prevState[v] != _this46.state[v];
			}).length) {
				this.validate();
				this.props.updatePage(this.state);
			}
		}
	}]);

	return Page4;
}(_react.Component);

var Page3 = function (_Component15) {
	_inherits(Page3, _Component15);

	function Page3(props) {
		_classCallCheck(this, Page3);

		var _this47 = _possibleConstructorReturn(this, (Page3.__proto__ || Object.getPrototypeOf(Page3)).call(this, props));

		_this47.state = Object.assign({}, _this47.props.page);
		return _this47;
	}

	// FIXME: The second text field here ("When are you available to start?") should be a date picker.

	_createClass(Page3, [{
		key: 'render',
		value: function render() {
			var _this48 = this;

			return _react2.default.createElement(
				'section',
				null,
				_react2.default.createElement(TextField, { asRow: true, label: 'What is the salary you desire for this job? *', placeholder: '$0', value: this.state.salary, setValue: function setValue(value) {
						return _this48.setState({ salary: value });
					} }),
				_react2.default.createElement(DateField, { hasDate: true, withoutYear: true, asRow: true, label: 'When are you available to start? *', placeholder: '', value: this.state.dateToStartValue || this.state.dateToStart || "",
					setValue: function setValue(value) {
						return _this48.setState({ dateToStartValue: value, dateToStart: _date.View.format(value, { ignoreYear: true, defaultValue: 'Now' }) });
					}
				}),
				_react2.default.createElement(_checkbox2.default, { asToggle: true, label: 'Are you available to work weekends?', value: this.state.weekends, setValue: function setValue(value) {
						return _this48.setState({ weekends: value });
					} }),
				_react2.default.createElement(_checkbox2.default, { asToggle: true, label: 'If needed, are you available to work overtime?', value: this.state.overtime, setValue: function setValue(value) {
						return _this48.setState({ overtime: value });
					} }),
				_react2.default.createElement(_checkbox2.default, { asToggle: true, label: 'If selected for employment are you willing to submit to a pre-employment drug screening test?', value: this.state.drugtest, setValue: function setValue(value) {
						return _this48.setState({ drugtest: value });
					} })
			);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.props.setCanMoveForward(this.state.salary && this.state.dateToStart ? true : false);
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			var _this49 = this;

			if (['salary', 'dateToStart', 'weekends', 'overtime', 'drugtest'].filter(function (v) {
				return prevState[v] != _this49.state[v];
			}).length) {
				if (this.state.salary && this.state.dateToStart) {
					this.props.setCanMoveForward(true);
				} else {
					this.props.setCanMoveForward(false);
				}
				this.props.updatePage(this.state);
			}
		}
	}]);

	return Page3;
}(_react.Component);

var Page2 = function (_Component16) {
	_inherits(Page2, _Component16);

	function Page2(props) {
		_classCallCheck(this, Page2);

		var _this50 = _possibleConstructorReturn(this, (Page2.__proto__ || Object.getPrototypeOf(Page2)).call(this, props));

		_this50.state = Object.assign({}, _this50.props.page);
		return _this50;
	}

	_createClass(Page2, [{
		key: 'render',
		value: function render() {
			var _this51 = this;

			return _react2.default.createElement(
				'section',
				null,
				_react2.default.createElement(
					'header',
					null,
					_react2.default.createElement(
						'h4',
						null,
						'What type of job are you applying for?'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'buttonColumn' },
					_react2.default.createElement(
						'button',
						{ className: _classList2.default.join('delivery', this.state.jobType == 'delivery' ? 'active' : ''), onClick: function onClick() {
								return _this51.setState({ jobType: 'delivery' });
							} },
						'Delivery'
					),
					_react2.default.createElement(
						'button',
						{ className: _classList2.default.join('maintenance', this.state.jobType == 'maintenance' ? 'active' : ''), onClick: function onClick() {
								return _this51.setState({ jobType: 'maintenance' });
							} },
						'Maintenance'
					),
					_react2.default.createElement(
						'button',
						{ className: _classList2.default.join('retail', this.state.jobType == 'retail' ? 'active' : ''), onClick: function onClick() {
								return _this51.setState({ jobType: 'retail' });
							} },
						'Retail'
					)
				)
			);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.props.setCanMoveForward(this.state.jobType != '');
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.jobType != this.state.jobType) {
				if (this.state.jobType) {
					this.props.updatePage(this.state);
					this.props.setCanMoveForward(true);
					return;
				}
				this.props.setCanMoveForward(false);
			}
		}
	}]);

	return Page2;
}(_react.Component);

var Page1 = function (_Component17) {
	_inherits(Page1, _Component17);

	function Page1(props) {
		_classCallCheck(this, Page1);

		var _this52 = _possibleConstructorReturn(this, (Page1.__proto__ || Object.getPrototypeOf(Page1)).call(this, props));

		_this52.state = Object.assign({}, _this52.props.page);
		return _this52;
	}

	_createClass(Page1, [{
		key: 'render',
		value: function render() {
			var _this53 = this;

			return _react2.default.createElement(
				'section',
				null,
				_react2.default.createElement(
					'header',
					null,
					_react2.default.createElement(
						'h3',
						null,
						'Application'
					),
					_react2.default.createElement(
						'h1',
						null,
						this.props.job.title
					),
					_react2.default.createElement(
						'h4',
						null,
						'To begin your application, please provide the following information.'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'item-row' },
					_react2.default.createElement(TextField, { label: 'First Name *', value: this.state.firstName, setValue: function setValue(value) {
							return _this53.setState({ firstName: value });
						} }),
					_react2.default.createElement(TextField, { className: 'middle', label: 'Middle', value: this.state.middleName, setValue: function setValue(value) {
							return _this53.setState({ middleName: value });
						} }),
					_react2.default.createElement(TextField, { label: 'Last Name *', value: this.state.lastName, setValue: function setValue(value) {
							return _this53.setState({ lastName: value });
						} }),
					_react2.default.createElement(TextField, { label: 'Nickname (Optional)', value: this.state.nickname, setValue: function setValue(value) {
							return _this53.setState({ nickname: value });
						} })
				),
				_react2.default.createElement(
					'div',
					{ className: 'item-row' },
					_react2.default.createElement(TextField, { label: 'Address 1 *', value: this.state.address1, setValue: function setValue(value) {
							return _this53.setState({ address1: value });
						} }),
					_react2.default.createElement(TextField, { label: 'Address 2', value: this.state.address2, setValue: function setValue(value) {
							return _this53.setState({ address2: value });
						} })
				),
				_react2.default.createElement(
					'div',
					{ className: 'item-row' },
					_react2.default.createElement(TextField, { label: 'City *', value: this.state.city, setValue: function setValue(value) {
							return _this53.setState({ city: value });
						} }),
					_react2.default.createElement(ListBox, { label: 'State *', value: { id: this.state.state }, setValue: function setValue(value) {
							return _this53.setState({ state: value ? value.id : null });
						}, options: _lists.States }),
					_react2.default.createElement(TextField, { label: 'Zip *', value: this.state.zip, setValue: function setValue(value) {
							return _this53.setState({ zip: value });
						} })
				),
				_react2.default.createElement(
					'div',
					{ className: 'item-row' },
					_react2.default.createElement(TextField, { label: 'Email Address *', value: this.state.email, setValue: function setValue(value) {
							return _this53.setState({ email: value });
						} }),
					_react2.default.createElement(TextField, { label: 'Phone *', value: this.state.phone, setValue: function setValue(value) {
							return _this53.setState({ phone: value });
						} })
				),
				_react2.default.createElement(_checkbox2.default, { label: 'Yes, you may contact me by email.', value: this.state.contactByEmail, setValue: function setValue(value) {
						return _this53.setState({ contactByEmail: value });
					} }),
				_react2.default.createElement(_checkbox2.default, { label: 'Yes, I am legally authorized to work in the United States. *', value: this.state.canWorkInUS, setValue: function setValue(value) {
						return _this53.setState({ canWorkInUS: value });
					} })
			);
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			var _this54 = this;

			// Did state change?
			if (['firstName', 'lastName', 'address1', 'city', 'state', 'zip', 'email', 'phone', 'canWorkInUS'].filter(function (k) {
				return prevState[k] != _this54.state[k];
			}).length) {
				this.validate();
				this.props.updatePage(this.state);
			}

			if (['middleName', 'nickname', 'address2', 'contactByEmail'].filter(function (k) {
				return prevState[k] != _this54.state[k];
			}).length) this.props.updatePage(this.state);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.validate();
		}
	}, {
		key: 'validate',
		value: function validate() {
			var _this55 = this;

			var notEmpty = function notEmpty(value) {
				return !!value && String(value).replace(/\s*/g, '') != '';
			};
			var zip = function zip(value) {
				return notEmpty(value) && /^\s*[0-9]{5}\s*$/.test(value);
			};
			var email = function email(value) {
				return notEmpty(value) && /\s*[^@]+@.*$/.test(value);
			};
			var truth = function truth(value) {
				return value;
			};

			var validators = {
				firstName: notEmpty,
				lastName: notEmpty,
				address1: notEmpty,
				city: notEmpty,
				state: notEmpty,
				zip: zip,
				email: email,
				phone: notEmpty,
				canWorkInUS: truth
			};

			if (Object.keys(validators).filter(function (v) {
				return !validators[v](_this55.state[v]);
			}).length) {
				this.props.setCanMoveForward(false);
			} else {
				this.props.setCanMoveForward(true);
			}
		}
	}]);

	return Page1;
}(_react.Component);

var JobApplication = exports.JobApplication = function (_Component18) {
	_inherits(JobApplication, _Component18);

	_createClass(JobApplication, [{
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			var _this57 = this;

			try {
				window.localStorage.setItem('job-application/' + this.props.job.id, JSON.stringify({
					version: 1,
					state: this.state
				}));
			} catch (e) {
				;
			}

			if (this.state.status == 'submit') {
				/* Do our thing */
				if (true) {
					var xhr = new XMLHttpRequest();
					var data = {};
					Object.keys(this.state).forEach(function (key) {
						if (_typeof(_this57.state[key]) == 'object') data = Object.assign(data, _this57.state[key]);
					});
					xhr.open('POST', 'data/job/' + this.props.job.id, true);
					xhr.onreadystatechange = function () {
						if (xhr.readyState == 4) {
							_this57.setState({ status: 'complete' });
						}
					};
					xhr.setRequestHeader('Content-Type', 'application/json');
					xhr.send(JSON.stringify(data, null, 4));
					return;
				}

				setTimeout(function () {
					_this57.setState({ status: 'complete' });
				}, 2000);
			}

			if (this.state.status == 'complete') {
				try {
					// window.localStorage.removeItem(`job-application/${this.props.job.id}`);
				} catch (e) {
					;
				}
			}
		}
	}, {
		key: 'emptyWorkHistory',
		get: function get() {
			return {
				employerName: "",
				phone: "",
				address: "",
				city: "",
				state: "OR",
				zip: "",
				supervisorName: "",
				supervisorTitle: "",
				startDate: "",
				endDate: "",
				startingPay: "",
				endingPay: "",
				duties: "",
				canContact: true,
				hasMore: false
			};
		}
	}]);

	function JobApplication(props) {
		_classCallCheck(this, JobApplication);

		var _this56 = _possibleConstructorReturn(this, (JobApplication.__proto__ || Object.getPrototypeOf(JobApplication)).call(this, props));

		_this56.state = {
			// Page 1
			page1: {
				firstName: "",
				middleName: "",
				lastName: "",
				nickname: "",
				address1: "",
				address2: "",
				city: "",
				state: "OR",
				zip: "",
				email: "",
				phone: "",
				contactByEmail: null,
				canWorkInUS: null
			},

			// Page 2
			page2: {
				jobType: null
			},

			// Page 3
			page3: {
				salary: "",
				dateToStart: null,
				weekends: null,
				overtime: null,
				drugtest: null
			},

			// Page 4 (driving details: this might be conditional on jobType)
			page4: {
				driversLicense: false,
				trafficIncidents: 0,
				movingViolations: 0
			},

			// Page 5
			page5: {
				educationHS: null,
				educationCollege: null,
				educationTrade: null,
				educationMilitary: null
			},

			// Page 6: conditional on educationHS == true
			page6: {
				highSchoolName: "",
				highSchoolCity: "",
				highSchoolState: "OR",
				highSchoolStart: null,
				highSchoolEnd: null,
				highSchoolGraduated: null
			},

			// Page 7: conditional on educationCollege == true
			page7: {
				collegeName: "",
				collegeCity: "",
				collegeState: "OR",
				collegeStart: null,
				collegeEnd: null,
				collegeGraduated: null,
				// - conditional on graduation?
				collegeDegree: "",
				collegeDegreeYear: ""
			},

			// Page 8: conditional on educationTrade == true
			page8: {
				tradeSchool: ""
			},

			// Page 9: conditional on educationMilitary == true
			page9: {
				militaryBranch: "",
				militaryRank: "",
				militaryService: ""
			},

			// Page 10
			page10: {
				additionalEducation: "",
				skills: ""
			},

			// Page 11 (repeats until job information is complete)
			page11: {
				workHistory: [_this56.emptyWorkHistory]
			},

			// Page 12 (about)
			page12: {
				greatestStrengths: "",
				areasForImprovement: "",
				difficultPartOfManagement: "",
				whatMakesAGoodManager: ""
			},

			//Page 13
			page13: {
				leastFavoriteJobAndWhy: "",
				difficultPartOfCustomerService: "",
				funniestThing: ""
			},

			// Page 14
			page14: {
				reference1Name: "",
				reference1Relationship: "",
				reference1Email: "",
				reference1Phone: "",
				reference2Name: "",
				reference2Relationship: "",
				reference2Email: "",
				reference2Phone: ""
			},

			// Page 15
			page15: {
				agree: false
			},

			status: 'form'
		};
		try {
			var item = window.localStorage.getItem('job-application/' + _this56.props.job.id);
			if (item) {
				item = JSON.parse(item);
				if (item.version == 1) {
					_this56.state = item.state;
				}
			}
		} catch (e) {
			;
		}

		_this56.submitForm = _this56.submitForm.bind(_this56);
		_this56.state.status = 'form';
		return _this56;
	}

	_createClass(JobApplication, [{
		key: 'submitForm',
		value: function submitForm() {
			this.setState({
				status: 'submit'
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this58 = this;

			var job = this.props.job;
			if (this.state.status == 'submit') {
				return _react2.default.createElement(
					'div',
					{ className: 'wizard' },
					_react2.default.createElement(
						'div',
						{ className: 'wizard-body' },
						_react2.default.createElement(
							'section',
							null,
							_react2.default.createElement('img', { src: '/admin/images_shared/loading.gif' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'controls' },
						_react2.default.createElement('button', { style: { opacity: 0 }, disabled: true, className: 'btn btn-primary' })
					)
				);
			}
			if (this.state.status == 'complete') {
				return _react2.default.createElement(
					'div',
					{ className: 'wizard' },
					_react2.default.createElement(
						'div',
						{ className: 'wizard-body' },
						_react2.default.createElement(
							'section',
							null,
							_react2.default.createElement(
								'header',
								null,
								_react2.default.createElement(
									'h1',
									null,
									'Application Received'
								)
							),
							_react2.default.createElement(
								'p',
								null,
								'We have received your application for employment with The Pool & Spa House. Should your background and experience meet the requirements of one of our job openings, we will contact you to schedule an interview. If we do not have an appropriate opening at this time, we will retain your application for six months for future consideration.'
							),
							_react2.default.createElement(
								'p',
								null,
								'Thank you for your interest in a career opportunity with The Pool & Spa House'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'controls' },
						_react2.default.createElement(
							'button',
							{ className: 'btn btn-primary', onClick: this.props.closeModal },
							'Close'
						)
					)
				);
			}
			return _react2.default.createElement(
				Wizard,
				null,
				_react2.default.createElement(Page1, { job: job, page: this.state.page1, updatePage: function updatePage(page) {
						return _this58.setState({ page1: Object.assign({}, page) });
					} }),
				false && _react2.default.createElement(Page2, { job: job, page: this.state.page2, updatePage: function updatePage(page) {
						return _this58.setState({ page2: Object.assign({}, page) });
					} }),
				_react2.default.createElement(Page3, { job: job, page: this.state.page3, updatePage: function updatePage(page) {
						return _this58.setState({ page3: Object.assign({}, page) });
					} }),
				this.props.job.driving ? _react2.default.createElement(Page4, { job: job, page: this.state.page4, updatePage: function updatePage(page) {
						return _this58.setState({ page4: Object.assign({}, page) });
					} }) : null,
				_react2.default.createElement(Page5, { job: job, page: this.state.page5, updatePage: function updatePage(page) {
						return _this58.setState({ page5: Object.assign({}, page) });
					} }),
				this.state.page5.educationHS ? _react2.default.createElement(Page6, { job: job, page: this.state.page6, updatePage: function updatePage(page) {
						return _this58.setState({ page6: Object.assign({}, page) });
					} }) : null,
				this.state.page5.educationCollege ? _react2.default.createElement(Page7, { job: job, page: this.state.page7, updatePage: function updatePage(page) {
						return _this58.setState({ page7: Object.assign({}, page) });
					} }) : null,
				this.state.page5.educationTrade ? _react2.default.createElement(Page8, { job: job, page: this.state.page8, updatePage: function updatePage(page) {
						return _this58.setState({ page8: Object.assign({}, page) });
					} }) : null,
				this.state.page5.educationMilitary ? _react2.default.createElement(Page9, { job: job, page: this.state.page9, updatePage: function updatePage(page) {
						return _this58.setState({ page9: Object.assign({}, page) });
					} }) : null,
				_react2.default.createElement(Page10, { job: job, page: this.state.page10, updatePage: function updatePage(page) {
						return _this58.setState({ page10: Object.assign({}, page) });
					} }),
				this.state.page11.workHistory.map(function (workHistory, index) {
					return _react2.default.createElement(Page11, { key: index, isFirst: index == 0, job: job, page: workHistory, updatePage: function updatePage(page) {
							_this58.setState(function (state) {
								var p = state.page11.workHistory.slice();
								p[index] = page;
								if (page.hasMore) {
									if (!p[index + 1]) p[index + 1] = _this58.emptyWorkHistory;
								} else {
									p.length = index + 1;
								}
								return { page11: { workHistory: p } };
							});
						} });
				}),
				_react2.default.createElement(Page12, { job: job, page: this.state.page12, updatePage: function updatePage(page) {
						return _this58.setState({ page12: Object.assign({}, page) });
					} }),
				_react2.default.createElement(Page13, { job: job, page: this.state.page13, updatePage: function updatePage(page) {
						return _this58.setState({ page13: Object.assign({}, page) });
					} }),
				_react2.default.createElement(Page14, { job: job, page: this.state.page14, updatePage: function updatePage(page) {
						return _this58.setState({ page14: Object.assign({}, page) });
					} }),
				_react2.default.createElement(Page15, { job: job, page: this.state.page15, updatePage: function updatePage(page) {
						return _this58.setState({ page15: Object.assign({}, page) });
					}, nextButtonTitle: 'Submit' }),
				_react2.default.createElement(Page16, { submitForm: this.submitForm })
			);
			/*
   	<Page16 isLastPage={true} job={job} page={{}} updatePage={page => {}} />
   </Wizard>;
   */
		}
	}]);

	return JobApplication;
}(_react.Component);